import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

// La API key de Google Sheets está restringida a los dominios del sitio.
// En el navegador el Referer lo manda solo; en el render del servidor (SSR)
// no existe, así que lo agregamos acá para que el catálogo también se
// renderice server-side con la key restringida.
@Injectable()
export class RefererInterceptor implements HttpInterceptor {
  constructor(@Inject(PLATFORM_ID) private plataforma: object) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isPlatformServer(this.plataforma) && req.url.includes('sheets.googleapis.com')) {
      return next.handle(req.clone({ setHeaders: { Referer: 'https://soyiphone.com.ar/' } }));
    }
    return next.handle(req);
  }
}
